import React from "react";
import classnames from "classnames";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";

export default props => {
    let { error } = props;
    if (error && typeof error != "string") {
        error = (
            <span>
                Something went wrong, please try again or contact us at{" "}
                <a
                    href="mailto:info@thenounproject.com?subject=Download+Error"
                    title="info@thenounproject.com"
                >
                    info@thenounproject.com
                </a>
            </span>
        );
    }
    let errorDisplay = null;
    if (error) {
        errorDisplay = <div className="error download-flow-error">{error}</div>;
    }

    return errorDisplay;
};
